<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardIntro :cardContent="content" @funcRoute="funcRoute" />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardIntro from "../../components/template/Chinese1/CardIntro";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";


export default {
  components: { CardIntro, LoadingMDL },
  name: "CTT01",
  data() {
    return {
      content: {},
      lang: "",
      CheckWidth: window.innerWidth.toString(),
      courseCode: "",
      topicId: "",
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: "",
      startTime: "",
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      storeLanguage: "language/getLanguage",
      courseTopicID: "courses/getCourseTopicID",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    allCourse: function (val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    getUserTemplate: function (val) {
      this.userTemplateData = val;
      this.loading = false;
    },
    loadingGetter: function (val) {
      if (val == true) {
        this.$router.push(this.nextAction);
      }
    },
  },

  mounted() {},

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `CTT01-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    funcRoute(val) {
      const useTime = this.$helpers.getUseTime();
      // this.userTemplateData.template = this.$helpers.setUserCriteria(
      //   this.userTemplateData.template,
      //   useTime
      // );

      // if (this.userTemplateData.quiz.length !== 0) {
      //   this.userTemplateData.quiz = this.$helpers.setUserQuizScore(
      //     this.userTemplateData.quiz,
      //     this.score
      //   );
      // }
      if (typeof val === "string") {
        this.nextAction = this.$helpers.setChineseUrl(val);
      } else {
        this.$store.commit("necessary/setCodePage", val[1]);
        this.nextAction = "/" + val[0] + "/" + val[1];
      }
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: [],
      });
      /*
      this.$store.dispatch(
        "template/saveUserTemplateData",
        this.userTemplateData
      );
      */
    },
  },
};
</script>
<style>
</style>